import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import produce from 'immer';

const CHANGE_VALUE = 'carInfoSelect/CHANGE_VALUE';
export const changeValue = createAction(CHANGE_VALUE);
// 제조사 조회
const GET_MANUFACTURER = 'carInfoSelect/GET_MANUFACTURER';
export const getManufacturer = createAction(GET_MANUFACTURER, api.getManufacturer);
// 모델 그룹 조회
const GET_MODELGROUP = 'carInfoSelect/GET_MODELGROUP';
export const getModelGroup = createAction(GET_MODELGROUP, api.getModelGroup);
// 세부 모델 조회
const GET_MODEL = 'carInfoSelect/GET_MODEL';
export const getModel = createAction(GET_MODEL, api.getModel);

// 형식 조회
const GET_FORM = 'carInfoSelect/GET_FORM';
export const getForm = createAction(GET_FORM, api.getTruckForm);
// 세부형식 조회
const GET_FORM_DETAIL = 'carInfoSelect/GET_FORM_DETAIL';
export const getFormDetail = createAction(GET_FORM_DETAIL, api.getTruckFormDetail);
// 적재용량 조회
const GET_CAPACITY = 'carInfoSelect/GET_CAPACITY';
export const getCapacity = createAction(GET_CAPACITY, api.getTruckCapacity);
// 트럭 제조사 조회
const GET_MANUFACTURER_TRUCK = 'carInfoSelect/GET_MANUFACTURER_TRUCK';
export const getManufacturerTruck = createAction(GET_MANUFACTURER_TRUCK, api.getManufacturerTruck);
// 트럭 모델 조회
const GET_MODEL_TRUCK = 'carInfoSelect/GET_MODEL_TRUCK';
export const getModelTruck = createAction(GET_MODEL_TRUCK, api.getModelTruck);

const initialState = {
	carType: 'DOMESTIC',
	manufacturerCd: '',
	manufacturerItems: [],
	modelGroupCd: '',
	modelGroupItems: [],
	modelCd: '',
	modelItems: [],
	formCd: '',
	formItems: [],
	formDetailCd: '',
	formDetailItems: [],
	capacityCd: '',
	capacityItems: [],
	yearsCd: '',
	milage: '',
};

export default handleActions(
	{
		[CHANGE_VALUE]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;
				draft[name] = value;
			}),
		...pender({
			type: GET_MANUFACTURER,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const result = data === '' ? [] : data;
					draft.manufacturerItems = result || [];
				}),
		}),
		...pender({
			type: GET_MODELGROUP,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const result = data === '' ? [] : data;
					draft.modelGroupItems = result || [];
				}),
		}),
		...pender({
			type: GET_MODEL,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const result = data === '' ? [] : data;
					draft.modelItems = result || [];
				}),
		}),
		...pender({
			type: GET_FORM,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const result = data === '' ? [] : data;
					draft.formItems = result || [];
				}),
		}),
		...pender({
			type: GET_FORM_DETAIL,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const result = data === '' ? [] : data;
					draft.formDetailItems = result || [];
				}),
		}),
		...pender({
			type: GET_CAPACITY,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const result = data === '' ? [] : data;
					draft.capacityItems = result || [];
				}),
		}),
		...pender({
			type: GET_MANUFACTURER_TRUCK,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const result = data === '' ? [] : data;
					draft.manufacturerItems = result || [];
				}),
		}),
		...pender({
			type: GET_MODEL_TRUCK,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const result = data === '' ? [] : data;
					draft.modelItems = result || [];
				}),
		}),
	},
	initialState,
);
